(ns manatee.qa.view.item-group
  (:require
   [clojure.string :as string]
   [manatee.admin.task-config.subs :as task-config-subs]
   [manatee.annotation.components :as annotation-components]
   [manatee.components.part :as part-components]
   [manatee.components.table.formatters :as manatee-formatters]
   [manatee.domain.item :as item]
   [manatee.domain.task :as task]
   [manatee.qa.handlers :as handlers]
   [manatee.qa.subs :as subs]
   [manatee.qa.view.shared :as view-shared]
   [manatee.ui.templates :as templates]
   [re-frame.core :as rf]
   [rothko.button.component :refer [button]]
   [rothko.collection-components.core :as collection]
   [rothko.collection-components.table.component :as table]
   [rothko.icon-animated.component :refer [spinner]]
   [rothko.layout.component :refer [layout]]
   [rothko.panel.component :refer [panel]]))

(defn item-group-answers-table
  "Display answers for a given part."
  [answers viewed-items]
  [:div.part-answers
   [:h5 "Answers"]
   [table/component
    {:appearance #{:primary}
     ::collection/items (->> answers
                             (filter #(= :answer (:item-type %)))
                             (sort-by :question-number))
     ::collection/fields [{::collection/label "ID"
                           ::table/formatter (manatee-formatters/item-id-handler-selector
                                              (when (view-shared/go-back-only?)
                                                {"go-back-only" true}))}
                          {::collection/label "Seen"
                           ::table/formatter (manatee-formatters/qa-item-viewed-field viewed-items (constantly [:id]))}
                          {::collection/id :has-feedback?
                           ::collection/label "Feedback?"
                           ::table/formatter (manatee-formatters/transform-field
                                              :has-feedback?
                                              (comp string/capitalize str))}
                          {::collection/id :feedback-actioned?
                           ::collection/label "Feedback Actioned?"
                           ::table/formatter (manatee-formatters/transform-field
                                              :answer-has-feedback-actioned?
                                              (comp string/capitalize str))}
                          {::collection/id :annotation-state
                           ::collection/label "Annotation State"
                           ::table/formatter (manatee-formatters/annotation-state)}]}]])

(defn field-options->options
  [field-options]
  (for [{:keys [label value]} field-options]
    {:value (keyword value)
     :representation label}))

(defn item-edit-score
  [{:keys [task-config-id] :as edit}]
  (let [task-config @(rf/subscribe [::task-config-subs/task-config task-config-id])
        part-scoring-field (task/scoring-field task-config :part)
        score-name (:field-name part-scoring-field)
        options (some-> part-scoring-field :options
                        field-options->options)]
    (when options
      [part-components/score-selector {:disabled? true
                                       :score-name score-name
                                       :options options
                                       :init-value (-> edit score-name keyword)}])))

(defn approve-button
  [{:keys [edit] :as item}]
  (when (or (#{:requires-approval :rejected-requires-approval} (:status edit)) (:evaluator-edit? edit))
    [button {:appearance #{:primary :full-width}
             :on-click #(rf/dispatch [::handlers/approve-edit item])}
     "Approve"]))

(defn item-group-body
  [task-config {:keys [answer-items part-item previous-stage-item-groups]} viewed-items]
  [:<>
   [:h4 (cond
          (-> part-item :edits seq) "Review Completed Edit"
          (some (comp seq :reports) (cons part-item answer-items)) "Review Reported Edit"
          :else "Item Group")]
   [layout {:appearance #{:qa-view-details}}
    [view-shared/item-details task-config part-item]
    (when-let [part-edit (-> part-item :edits first)]
      [view-shared/edit-details task-config part-edit])]
   [:br]
   (when part-item
     [:h4 (item/part-label (:part part-item)
                           (task/task-config->part-description task-config
                                                               (:part part-item)))])
   (when (:short-rubric part-item)
     [:p (:short-rubric part-item)])
   (when (seq? previous-stage-item-groups)
     [part-components/previous-stage-annotations previous-stage-item-groups])
   [item-group-answers-table answer-items viewed-items]
   (when-let [part-edit (-> part-item :edits first)]
     [item-edit-score part-edit])
   [:div.action-buttons
    (if (view-shared/go-back-only?)
      [view-shared/go-back-button]
      [:<>
       [button {:appearance #{:secondary :full-width}
                :on-click #(rf/dispatch [:navigate-to [:manatee.edit.handlers/edits]])}
        "View all edits"]
       [approve-button part-item]])]])

(defn item-qa-loading-component-wrapper
  [loading-text component]
  (let [qa-loading @(rf/subscribe [::subs/qa-loading])]
    [:div.qa-view-container
     [annotation-components/alert-container]
     [panel {:appearance #{:primary}}
      (if qa-loading
        [:div
         [:h4 loading-text]
         [spinner {:size 20}]]
        component)]]))

(defn item-group-container
  []
  (let [item-group @(rf/subscribe [::subs/item-group])
        viewed-items @(rf/subscribe [::subs/viewed-items])
        task-config @(rf/subscribe [::task-config-subs/task-config (get-in item-group [:part-item :task-config-id])])]
    (item-qa-loading-component-wrapper "Loading item group.."
                                       [item-group-body task-config item-group viewed-items])))

(def item-group-page
  {:template templates/single-column
   :main item-group-container})
